<script>
    import ClassicBEditor from '@ckeditor/ckeditor5-build-classic'
    import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
    import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight'


    import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
    import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
    import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
    import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
    import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
    import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
    import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';
    import Heading from '@ckeditor/ckeditor5-heading/src/heading';
    import Image from '@ckeditor/ckeditor5-image/src/image';
    import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
    import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
    import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
    import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
    // import Link from '@ckeditor/ckeditor5-link/src/link';
    import List from '@ckeditor/ckeditor5-list/src/list';
    import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
    import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';



    import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

    export default{
        data(){
            return {
                editor: ClassicBEditor,
                editor1: DecoupledEditor,

                editor2: ClassicEditor,
                editorConfig: {
                    // plugins: [ Essentials, Paragraph, Bold, Italic ],
                    plugins: [ Paragraph],
                    // toolbar: [ 'bold', 'italic' ]
                },
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/main-content/common-vue/vue-ckeditor-config.vue